import { render } from "./NavBarComponent.vue?vue&type=template&id=45b70e9e&scoped=true"
const script = {}

import "./NavBarComponent.vue?vue&type=style&index=0&id=45b70e9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b70e9e"]])

export default __exports__